import React from 'react';

const BillboardPreviewCard = ({ item }) => (
    <a href={`/billboard/playlists/${item.id}`}
       className="block bg-white rounded-lg shadow-xs border border-gray-200 overflow-hidden hover:shadow-md transition-shadow">
        {item.thumbnail_url ? (
            <div className="aspect-video bg-gray-800">
                <img src={item.thumbnail_url} alt="" className="w-full h-full object-cover" />
            </div>
        ) : (
            <div className="aspect-video bg-gray-100 flex items-center justify-center">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#a0aec0" strokeWidth="1.5">
                    <polygon points="23 7 16 12 23 17 23 7" />
                    <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
                </svg>
            </div>
        )}
        <div className="p-3">
            <p className="font-medium text-gray-800 truncate">{item.name}</p>
        </div>
    </a>
);

export default BillboardPreviewCard;
